var map = {
	"./studio_auto-unavailable.svg": 421,
	"./studio_europe-unavailable.svg": 422,
	"./studio_international-unavailable.svg": 423,
	"./studio_proofreading-unavailable.svg": 424,
	"./studio_unilingual-unavailable.svg": 425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;